module.exports = __webpack_public_path__ + "static/media/as_airdrop_bg.6fb0a077.png";